module.exports = __webpack_public_path__ + "img/绵绵爱意座位框.981ad23c.png";